module.exports = __webpack_public_path__ + "1ace29c02ffbda05c917174819f13dc7.svg";